module.exports = __webpack_public_path__ + "84e5b7f6.png";